import $ from 'jquery';
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom'

if( $( '.lightgallery' ).length  ) {
  lightGallery(document.querySelector('.lightgallery-interior'), {
    plugins: [lgZoom],
    licenseKey: '16281FE2-62F0-42E9-B381-A654A0B2DC50'
  });

  lightGallery(document.querySelector('.lightgallery-exterior'), {
    plugins: [lgZoom],
    licenseKey: '16281FE2-62F0-42E9-B381-A654A0B2DC50'
  });


  $('.gallery-button').click(function() {
    const $gallery = $(this).siblings('.gallery');
    $gallery.addClass('selected');
    $(this).css('display', 'none');
    
    // Update masonry layout after showing all images
    setTimeout(() => {
      const masonry = $gallery.data('masonry');
      if (masonry) {
        // Update layout immediately since images have background colors
        masonry.layout();
      }
    }, 100);
  });
}



